import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  InputLabel,
  LinearProgress,
  MenuItem,
  Modal,
  Select,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  Grid,
  RadioGroup,
  FormControlLabel,
  Radio,
  Switch,
} from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import { useRouter } from "next/router";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import StripePaymentModal from "../Modal/StripePaymentModal";
import { setCookie } from "../utils/cookie";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import KeyboardDoubleArrowUpIcon from "@mui/icons-material/KeyboardDoubleArrowUp";

const stripePromise = loadStripe(process.env.NEXT_PUBLIC_PAYMENT_PUBLIC_KEY);

// This component is now a standalone sign-up page and is no longer wrapped in a modal.
const SignUpForm = () => {
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleCloseNew = () => setOpen(false); // Using Next.js router for navigation
  const [isVisible, setIsVisible] = useState([]);

  const handleToggle = (i) => {
    // setIsVisible(!isVisible);
    setIsVisible(prev => {
      const next = [...prev];
      next[i] = !prev[i];
      return next;
    });
  };

  // All your existing state hooks and functions remain here
  const [formData, setFormData] = useState([
    {
      firstname: "",
      lastname: "",
      email: "",
      phone: null,
      gender: "",
      state: "",
      address: "",
      dob: "",
      time_of_birth: "",
      relationship_status: "",
      personality: "",
      strengths: "",
      lifeAreasFulfilling: "",
      lifeAreasImprovement: "",
      longTermGoals: "",
      majorLifeEvents: "",
      stressManagement: "",
      workLifeBalance: "",
      occupation: "",
      relationship_with_family: "",
      biggest_current_challenges: "",
      focus_on_specific_relationships: "",
      guidance_on_specific_decision: "",
      concerns_about_romantic_life: "",
      ongoing_projects_or_plans: "",
      social_life_fulfillment: "",
      spiritualPractices: "",
      selfDiscovery: "",
      externalInfluences: "",
      achieveFromReading: "",
      specificQuestions: "",
      goalsOutcomes: "",
      practicalSpiritualPref: "",
      mainConcern: "",
      additionalInfo: "",
      sub_relation: "",
    },
  ]);
  const [error, setError] = useState(Array(formData.length).fill({}));
  const [loader, setLoader] = useState(false);
  const [showPass, setShowPass] = useState(false);
  const [showConPass, setShowConPass] = useState(false);
  const [snackbarState, setSnackbarState] = useState(false);
  const [snackbarMassage, setSnackbarMassage] = useState("");
  const [userName, setUserName] = useState("");
  const [clientSecret, setClientSecret] = useState("");
  const [stripeProcessing, setStripeProcessing] = useState(false);
  const [stripeError, setStripeError] = useState(null);
  const [isStripeModalOpen, setIsStripeModalOpen] = useState(false);
  const [stripeCustomerId, setStripeCustomerId] = useState(null);
  const [stripeSubscriptionId, setStripeSubscriptionId] = useState(null);
  const [stripeUserId, setStripeUserId] = useState(null);
  const [stripeUserEmail, setStripeUserEmail] = useState(null);
  const [amount_and_type, setAmount_And_type] = useState({
    type: "Single",
    amount: 19.95,
    currency: "USD",
    interval: "month",
  });
  const [pricingData, setPricingData] = useState(null);
  const [pricingLoading, setPricingLoading] = useState(true);
  const [pricingError, setPricingError] = useState(null);
  const [paymentDetailsForCookie, setPaymentDetailsForCookie] = useState(null);
  const fieldRefs = React.useRef({});
  const [cityOptions, setCityOptions] = useState([]);
  const [cityLatLon, setCityLatLon] = useState({});
  const formatPlanPrice = (amount, currency = "USD") =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: currency || "USD",
    }).format(amount ?? 0);

  const StateArray = [
    { name: "Alabama", val: "AL" },
    { name: "Alaska", val: "AK" },
    { name: "Arizona", val: "AZ" },
    { name: "Arkansas", val: "AR" },
    { name: "California", val: "CA" },
    { name: "Colorado", val: "CO" },
    { name: "Connecticut", val: "CT" },
    { name: "Delaware", val: "DE" },
    { name: "Florida", val: "FL" },
    { name: "Georgia", val: "GA" },
    { name: "Hawaii", val: "HI" },
    { name: "Idaho", val: "ID" },
    { name: "Illinois", val: "IL" },
    { name: "Indiana", val: "IN" },
    { name: "Iowa", val: "IA" },
    { name: "Kansas", val: "KS" },
    { name: "Kentucky", val: "KY" },
    { name: "Louisiana", val: "LA" },
    { name: "Maine", val: "ME" },
    { name: "Maryland", val: "MD" },
    { name: "Massachusetts", val: "MA" },
    { name: "Michigan", val: "MI" },
    { name: "Minnesota", val: "MN" },
    { name: "Mississippi", val: "MS" },
    { name: "Missouri", val: "MO" },
    { name: "Montana", val: "MT" },
    { name: "Nebraska", val: "NE" },
    { name: "Nevada", val: "NV" },
    { name: "New Hampshire", val: "NH" },
    { name: "New Jersey", val: "NJ" },
    { name: "New Mexico", val: "NM" },
    { name: "New York", val: "NY" },
    { name: "North Carolina", val: "NC" },
    { name: "North Dakota", val: "ND" },
    { name: "Ohio", val: "OH" },
    { name: "Oklahoma", val: "OK" },
    { name: "Oregon", val: "OR" },
    { name: "Pennsylvania", val: "PA" },
    { name: "Rhode Island", val: "RI" },
    { name: "South Carolina", val: "SC" },
    { name: "South Dakota", val: "SD" },
    { name: "Tennessee", val: "TN" },
    { name: "Texas", val: "TX" },
    { name: "Utah", val: "UT" },
    { name: "Vermont", val: "VT" },
    { name: "Virgin Islands", val: "VI" },
    { name: "Virginia", val: "VA" },
    { name: "Washington", val: "WA" },
    { name: "West Virginia", val: "WV" },
    { name: "Wisconsin", val: "WI" },
    { name: "Wyoming", val: "WY" },
  ];

  const handleClose = () => {
    router.push("/");
  };

  const handleCloseStripeModal = () => {
    setIsStripeModalOpen(false);
    setUserName("");
    setClientSecret("");
    setStripeProcessing(false);
    setStripeError(null);
    setStripeCustomerId(null);
    setStripeSubscriptionId(null);
    setStripeUserId(null);
    setStripeUserEmail(null);
  };

  useEffect(() => {
    console.log("Form data has been updated:===========>", formData);
  }, [formData]);

  // --- NEW PRICING FETCH LOGIC ---
  useEffect(() => {
    const fetchPricing = async () => {
      try {
        setPricingLoading(true);
        setPricingError(null);
        //       const res = await fetch(
        //   // "https://astrologypro.com/api/pricing/perennial_mandalism_community"
        //   "http://localhost:3001/api/pricing/perennial_mandalism_community"
        // );
        const res = await fetch("/api/pricing/perennial-mandalism-community");

        if (!res.ok) {
          console.error("Pricing API Error - Status:", res.status, res.statusText);
        }

        const data = await res.json();
        console.log("Pricing API Response Data:", data);

        if (data && Array.isArray(data.plans)) {
          console.log("Successfully loaded plans from API:", data.plans);
          const normalized = {};
          data.plans.forEach((plan) => {
            if (plan.plan_id === "plan_pm_individual") {
              normalized.Single = plan;
            } else if (plan.plan_id === "plan_pm_couple") {
              normalized.Couple = plan;
            } else if (plan.plan_id === "plan_pm_family") {
              normalized.Family = plan;
            }
          });
          setPricingData(normalized);
        } else {
          console.error("Invalid pricing data format received from API. Expected 'plans' array.", data);
          setPricingError("Invalid pricing data format received.");
        }
      } catch (err) {
        console.log("Pricing API Network/Parsing Error:", err);
        setPricingError("Unable to load pricing details at this time.");
      } finally {
        setPricingLoading(false);
      }
    };
    fetchPricing();
  }, []);


  const handelFormData = (e, index) => {
    const { name, value } = e.target;


    setFormData((currentFormData) => {

      const newFormData = [...currentFormData];


      const updatedItem = {
        ...newFormData[index],
        [name]: value,
      };


      if (name === "relation") {
        updatedItem.sub_relation = "";
      }


      newFormData[index] = updatedItem;

      return newFormData;
    });


    setError((currentError) => {
      const newError = [...currentError];
      if (newError[index] && newError[index][name]) {
        delete newError[index][name];
      }
      return newError;
    });

    if (stripeError) setStripeError(null);
  };

  const validateForm = () => {
    let obj = [...formData];
    let errorObj = Array(formData.length).fill({});
    let firstErrorKey = null;

    const setErrorAndTrackFirst = (index, fieldName, message) => {
      errorObj[index] = { ...errorObj[index], [fieldName]: message };
      if (!firstErrorKey) {
        firstErrorKey = `${index}_${fieldName}`;
      }
    };

    obj.forEach((item, index) => {


      if (index !== 0) {
        if (!item.relation) {
          setErrorAndTrackFirst(index, "relation", "* Relation is required");
        } else {
          // Sub-Relation validation
          if (!item.sub_relation) {
            setErrorAndTrackFirst(
              index,
              "sub_relation",
              "* Relationship type is required"
            );
          }
        }
      }
      // Firstname
      if (!item.firstname) {
        setErrorAndTrackFirst(index, "firstname", "* This field is required");
      }

      // Lastname
      if (!item.lastname) {
        setErrorAndTrackFirst(index, "lastname", "* This field is required");
      }

      if (!item.time_of_birth) {
        setErrorAndTrackFirst(
          index,
          "time_of_birth",
          "* This field is required"
        );
      }

      if (!item.dob) {
        setErrorAndTrackFirst(index, "dob", "* This field is required");
      }
      // Email
      if (!item.email) {
        setErrorAndTrackFirst(index, "email", "* This field is required");
      } else {
        const originalEmail = String(item.email);
        const trimmedEmail = originalEmail.trim();
        if (trimmedEmail === "") {
          setErrorAndTrackFirst(
            index,
            "email",
            "* This field is required (cannot be only spaces)"
          );
        } else if (originalEmail !== trimmedEmail) {
          setErrorAndTrackFirst(
            index,
            "email",
            "* Email should not have leading or trailing spaces."
          );
        } else if (!/\S+@\S+\.\S+/.test(trimmedEmail)) {
          setErrorAndTrackFirst(index, "email", "* Invalid email format");
        }
      }
      // Phone
      if (!item.phone) {
        setErrorAndTrackFirst(index, "phone", "* This field is required");
      } else if (item.phone.length < 14) {
        setErrorAndTrackFirst(index, "phone", "Invalid Input");
      }
      // Gender
      if (!item.gender) {
        setErrorAndTrackFirst(index, "gender", "* Gender is required");
      }
      // State
      if (!item.state) {
        setErrorAndTrackFirst(index, "state", "* State is required");
      }
      // City
      if (!item.city) {
        setErrorAndTrackFirst(index, "city", "* City is required");
      }
      // Zip
      if (!item.zip) {
        setErrorAndTrackFirst(index, "zip", "* This field is required");
      } else if (item.zip.length < 5 || item.zip.length > 5) {
        setErrorAndTrackFirst(index, "zip", "Invalid Input");
      }
      // Address
      if (!item.address) {
        setErrorAndTrackFirst(index, "address", "* This field is required");
      }
      // Occupation
      if (!item.occupation) {
        setErrorAndTrackFirst(index, "occupation", "* This field is required");
      }
      // Password
      if (!item.password) {
        setErrorAndTrackFirst(index, "password", "* Password is Required");
      } else {
        const originalPassword = String(item.password);
        const trimmedPassword = originalPassword.trim();
        if (trimmedPassword === "") {
          setErrorAndTrackFirst(
            index,
            "password",
            "* Password is Required (cannot be only spaces)"
          );
        } else if (originalPassword !== trimmedPassword) {
          setErrorAndTrackFirst(
            index,
            "password",
            "* Password should not have leading or trailing spaces."
          );
        } else if (
          !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=]).{8,15}$/.test(
            trimmedPassword
          )
        ) {
          setErrorAndTrackFirst(
            index,
            "password",
            "* Invalid Password (8-15 chars, upper, lower, digit, symbol)"
          );
        }
      }
      // Confirm Password
      if (!item.confirm_password) {
        setErrorAndTrackFirst(
          index,
          "confirm_password",
          "* This field is required"
        );
      } else {
        const originalConfirmPassword = String(item.confirm_password);
        const trimmedConfirmPassword = originalConfirmPassword.trim();
        const trimmedPassword = item.password
          ? String(item.password).trim()
          : "";

        if (trimmedConfirmPassword === "") {
          setErrorAndTrackFirst(
            index,
            "confirm_password",
            "* This field is required (cannot be only spaces)"
          );
        } else if (originalConfirmPassword !== trimmedConfirmPassword) {
          setErrorAndTrackFirst(
            index,
            "confirm_password",
            "* Confirm Password should not have leading or trailing spaces."
          );
        } else if (trimmedPassword !== trimmedConfirmPassword) {
          setErrorAndTrackFirst(
            index,
            "confirm_password",
            "* Passwords do not match"
          );
        }
      }
    });

    setError(errorObj);
    return {
      isValid: !firstErrorKey,
      firstErrorKey: firstErrorKey,
    };
  };

  const fetchCitySuggestions = async (searchString) => {
    if (!searchString || searchString.length < 1) {
      setCityOptions([]);
      return;
    }
    try {
      const res = await axios.post(
        `https://d36fwfwo4vnk9h.cloudfront.net/astro-ai/fetch_city_with_latLon`,
        { searchcondition: { search_string: searchString } }
      );
      if (res.data?.status === "success" && Array.isArray(res.data.res)) {
        setCityOptions(res.data.res);
      } else {
        setCityOptions([]);
      }
    } catch (err) {
      console.error("Error fetching city suggestions:", err);
      setCityOptions([]);
    }
  };
  useEffect(() => {
    fetchCitySuggestions("a");
  }, []);

  function debounce(func, delay) {
    let timeoutId;
    return (...args) => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }
  const debouncedFetchCitySuggestions = useCallback(
    debounce(fetchCitySuggestions, 400),
    []
  );

  const fetchCityLatLon = async (cityVal) => {
    // Implementation as before
  };

  const getFieldRef = (index, name) => {
    const key = `${index}_${name}`;
    if (!fieldRefs.current[key]) {
      fieldRefs.current[key] = React.createRef();
    }
    return fieldRefs.current[key];
  };

  const handleSignupAndInitiatePayment = async () => {
    const validationResult = validateForm();

    if (!validationResult.isValid) {
      setSnackbarState(true);
      setSnackbarMassage("Please fill all the required fields.");

      // ---- THIS IS THE NEW SCROLLING LOGIC ----//

      if (validationResult.firstErrorKey) {
        const errorFieldRef = fieldRefs.current[validationResult.firstErrorKey];
        if (errorFieldRef && errorFieldRef.current) {
          errorFieldRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
          // Try to focus the actual input/textarea inside the component
          const inputElement =
            errorFieldRef.current.querySelector("input, textarea");
          if (inputElement) {
            inputElement.focus({ preventScroll: true });
          }
        }
      }
      return; // Stop the function
    }

    // --- The rest of your function remains unchanged ---
    setLoader(true);
    setStripeError(null);

    const requiredFields = [
      "firstname",
      "lastname",
      "email",
      "phone",
      "gender",
      "state",
      "address",
      "city",
      "zip",
      "occupation",
      "password",
      "confirm_password",
      "time_of_birth",
      "dob",
    ];

    // const filteredFormData = formData.filter((item) =>
    //   requiredFields.every(
    //     (field) => item[field] && String(item[field]).trim() !== ""
    //   )
    // );

    const filteredFormData = formData.filter((item) => {
      let isItemValid = requiredFields.every(
        (field) => item[field] && String(item[field]).trim() !== ""
      );

      // Add conditional check for sub_relation for non-main users
      if (item.relation && !item.sub_relation) {
        isItemValid = false;
      }
      return isItemValid;
    });

    if (filteredFormData.length === 0) {
      setSnackbarState(true);
      setSnackbarMassage("No valid entries to submit. Please check your form.");
      setLoader(false);
      return;
    }

    // The existing signup and payment logic...
    try {
      let signupPayload = filteredFormData.map((obj) => {
        const cleaned = {};
        Object.keys(obj).forEach((key) => {
          if (
            obj[key] !== "" &&
            obj[key] !== null &&
            obj[key] !== undefined &&
            obj[key] !== false
          ) {
            cleaned[key] = obj[key];
          }
        });
        return cleaned;
      });
      // ... (rest of your try-catch block is the same)
      let localAmount = 19.95;
      let localRelation = "Single";
      let localStripePriceId = null;
      let localPlanId = null;
      let localCurrency = "USD";
      let localInterval = "month";

      /* --- Legacy Hardcoded Pricing Logic ---
      if (signupPayload.length > 2) {
        localAmount = 39.95;
        localRelation = "Family";
      } else if (signupPayload.length > 1) {
        localAmount = 29.95;
        localRelation = "Couple";
      }
      --------------------------------------- */

      if (signupPayload.length > 2) {
        localRelation = "Family";
      } else if (signupPayload.length > 1) {
        localRelation = "Couple";
      }

      if (pricingData && pricingData[localRelation]) {
        localAmount = pricingData[localRelation].recurring_amount ?? pricingData[localRelation].amount;
        localStripePriceId = pricingData[localRelation].stripe_price_id;
        localPlanId = pricingData[localRelation].plan_id;
        localCurrency =
          pricingData[localRelation].recurring_currency ??
          pricingData[localRelation].currency ??
          "USD";
        localInterval = pricingData[localRelation].recurring_interval ?? "month";
      } else {
        // Fallbacks if API failed but we somehow reached here
        if (localRelation === "Family") localAmount = 39.95;
        else if (localRelation === "Couple") localAmount = 29.95;
      }

      signupPayload.forEach((obj, index) => {
        obj.mandalism = true;
        obj.user_type = "is_Perennial_Mandalism";
        if (index === 0) {
          obj.membership_type = localRelation;
          obj.membership_amount = localAmount;
          obj.membership_plan_id = localPlanId; // Add API details for backend
          obj.stripe_price_id = localStripePriceId;
          obj.currency = localCurrency;
          obj.billing_interval = localInterval;
          obj.is_main_user = true;
        }
      });

      const signupReq = await fetch(
        `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}user/signup`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(signupPayload),
        }
      );

      // console.log("Signup request payload:", signupPayload);

      const signupRes = await signupReq.json();
      console.log("Signup response:", signupRes);

      const sqsCall = fetch(
        `https://a5p6f3zd26utex5rxmbu7vromu0jsszy.lambda-url.us-east-1.on.aws/`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            steps: ["perenial_report"],
            user_ids: signupRes?.results?.updatesToDatabase,
          }),
        }
      );
      console.log("SQS call response:", sqsCall);

      if (
        signupRes.status === "success" &&
        signupRes.results?.main_id &&
        signupRes.results?.main_email
      ) {
        console.log("Signup successful:", signupRes.results);
        setStripeUserId(signupRes.results.main_id);
        setStripeUserEmail(signupRes.results.main_email);
        setSnackbarState(true);
        setSnackbarMassage("Signup successful! Proceeding to payment...");

        try {
          console.log("Calling subscription-payment...");
          const paymentPayload = {
            customer_id: signupRes.results.main_id,
            email: signupRes.results.main_email,
            membership_type: localRelation,
            membership_amount: localAmount,
            currency: localCurrency,
            billing_interval: localInterval,
            price_id: localStripePriceId,
            plan_id: localPlanId
          };

          const paymentReq = await fetch(
            `${process.env.NEXT_PUBLIC_API_CLOUDFRONT}cart_management/subscription-payment`,
            {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify(paymentPayload),
            }
          );

          const paymentRes = await paymentReq.json();

          if (paymentRes.status === "success" && paymentRes.clientSecret) {
            console.log("Subscription initiation successful:", paymentRes);
            setUserName(
              signupPayload[0].firstname + " " + signupPayload[0].lastname
            );
            setClientSecret(paymentRes.clientSecret);
            setStripeCustomerId(paymentRes.customerId);
            setStripeSubscriptionId(paymentRes.subscriptionId);
            setPaymentDetailsForCookie({
              price_id: signupPayload[0].stripe_price_id,
              plan_id: signupPayload[0].membership_plan_id,
              membership_type: signupPayload[0].membership_type,
              membership_amount: signupPayload[0].membership_amount,
              currency: signupPayload[0].currency,
              billing_interval: signupPayload[0].billing_interval,
            });
            setIsStripeModalOpen(true);
            setSnackbarState(true);
            setSnackbarMassage("Please enter your payment details.");
          } else {
            setStripeError(
              "Failed to set up subscription payment. Please try again."
            );
            setSnackbarState(true);
            setSnackbarMassage("Failed to set up subscription payment.");
          }
        } catch (paymentError) {
          setStripeError("An network error occurred while setting up payment.");
          setSnackbarState(true);
          setSnackbarMassage(
            "An error occurred setting up payment. Please try again."
          );
        }
      } else {
        if (signupRes.message.includes("already exists")) {
          setSnackbarState(true);
          setSnackbarMassage(signupRes.message);
        } else {
          setStripeError(
            "Signup failed. Please check your details and try again."
          );
          setSnackbarState(true);
          setSnackbarMassage("Signup failed.");
        }
      }
    } catch (signupError) {
      setStripeError("An network error occurred during signup.");
      setSnackbarState(true);
      setSnackbarMassage("An error occurred during signup. Please try again.");
    } finally {
      setLoader(false);
    }
  };

  // --- ALL REMAINING FUNCTIONS AND JSX ARE UNCHANGED ---
  const handleStripeSubmit = async (stripe, elements) => {
    setStripeProcessing(true);
    setStripeError(null);

    if (
      stripeCustomerId &&
      stripeSubscriptionId &&
      stripeUserId &&
      stripeUserEmail
    ) {
      const cookiebody = {
        customer_id: stripeCustomerId,
        subscription_id: stripeSubscriptionId,
        user_id: stripeUserId,
        email: stripeUserEmail,
        ...(userName && { name: userName }),
        ...(paymentDetailsForCookie || {})
      };
      try {
        console.log("Setting stripeUserDetails cookie:", cookiebody);
        setCookie("stripeUserDetails", JSON.stringify(cookiebody), {
          path: "/",
        });
      } catch (cookieError) {
        setStripeError(
          "Could not save user details locally. Please try again."
        );
        setSnackbarState(true);
        setSnackbarMassage("Error saving user details. Payment not attempted.");
        setStripeProcessing(false);
        return;
      }
    } else {
      setStripeError(
        "Required user/subscription details are missing. Cannot proceed."
      );
      setSnackbarState(true);
      setSnackbarMassage("Cannot proceed: Missing required details.");
      setStripeProcessing(false);
      return;
    }

    const returnUrl = `${window.location.origin}/stripe-success-page`;

    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: returnUrl,
      },
      redirect: "always",
    });

    if (error) {
      if (error.type === "card_error" || error.type === "validation_error") {
        setStripeError(error.message);
        setSnackbarState(true);
        setSnackbarMassage(`Payment failed: ${error.message}`);
      } else {
        setStripeError("An unexpected error occurred during payment.");
        setSnackbarState(true);
        setSnackbarMassage("An unexpected error occurred. Please try again.");
      }
      setStripeProcessing(false);
    }
  };

  const addFields = () => {
    let obj = [...formData];
    obj.push({
      relation: "",
      sub_relation: "",
      firstname: "",
      lastname: "",
      email: "",
      phone: null,
      address: "",
    });
    setFormData(obj);
  };

  const removePartner = (index) => {
    let updatedFormData = [...formData];
    updatedFormData.splice(index, 1);
    setFormData(updatedFormData);
    let updatedError = [...error];
    updatedError.splice(index, 1);
    setError(updatedError);
  };

  const phoneFormatting = (event, index) => {
    if (event.target.value.split("").length <= 14) {
      let formatted = formatPhoneText(event.target.value);
      let name = event.target.name;
      let obj = [...formData];
      obj[index][name] = formatted;
      setFormData(obj);
    }
  };

  function formatPhoneText(value) {
    value = value.trim().replaceAll("-", "");
    value = value.trim().replaceAll("(", "");
    value = value.trim().replaceAll(")", "");
    value = value.trim().replaceAll(" ", "");
    if (value.length > 3 && value.length <= 6)
      value = "(" + value.slice(0, 3) + ")" + " " + value.slice(3);
    else if (value.length > 6)
      value =
        "(" +
        value.slice(0, 3) +
        ")" +
        " " +
        value.slice(3, 6) +
        "-" +
        value.slice(6);
    return value;
  }

  useEffect(() => {
    const memberCount = formData.length;
    let newAmount = 19.95;
    let newType = "Single";
    let familyFound = false;
    let coupleFound = false;

    // --- Legacy Hardcoded Pricing Type Logic ---
    // if (memberCount > 2) {
    //   newAmount = 39.95;
    // } else if (memberCount === 2) {
    //   newAmount = 29.95;
    // }
    // -------------------------------------------

    if (memberCount > 1) {
      for (let i = 1; i < formData.length; i++) {
        if (formData[i].relation?.toLowerCase() === "family") {
          familyFound = true;
          break;
        } else if (formData[i].relation?.toLowerCase() === "couple") {
          coupleFound = true;
        }
      }

      if (familyFound) {
        newType = "Family";
      } else if (coupleFound) {
        newType = "Couple";
      } else {
        newType = memberCount > 2 ? "Family" : "Couple";
      }
    }

    if (pricingData && pricingData[newType]) {
      newAmount =
        pricingData[newType].recurring_amount ?? pricingData[newType].amount;
    } else {
      if (newType === "Family") newAmount = 39.95;
      else if (newType === "Couple") newAmount = 29.95;
    }

    const selectedPlan = pricingData?.[newType];

    setAmount_And_type({
      type: newType,
      amount: newAmount,
      currency:
        selectedPlan?.recurring_currency ?? selectedPlan?.currency ?? "USD",
      interval: selectedPlan?.recurring_interval ?? "month",
      planDetails: selectedPlan,
    });
  }, [formData, pricingData]);

  const appearance = {
    theme: "stripe",
    variables: { colorPrimary: "#0570de" },
    rules: {
      ".Label": { color: "#fff" },
      ".TermsText": { color: "#fff" },
      ".p-BankView--text": { color: "#fff" },
    },
  };
  const stripeOptions = { clientSecret, appearance };

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Function to check screen width
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 599);
    };

    // Set initial value
    handleResize();

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    // Your entire JSX return statement remains unchanged...
    <>
      <div className="main_wrpr_finddivine banner_modal_main_new perrenial_access_bnnr_main">
        <div className="ritualpraxis_blockone">
          {/* {/ <!------Main Banner section-------> /} */}
          <div className="ritualpraxis_banner_main_wrpr">
            <div className="ritualpraxis_banner_left">
              <div className="bannerLogo">
                <div className="bnnr_img1"> <span className="logoviewlink" onClick={handleOpen}>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/viewicon.png" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/viewicon.png`}
                    alt="view_icon"
                  />
                </span>
                  {/* <img src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp" /> */}
                  <img
                    src={`${process.env.cloud_url2}assets/images/logobanner.webp`}
                    alt="banner_logo"
                  /></div>
                <div className="bnnr_img2"><img className="astrologypro_bnnr_logo"
                  src="/image/astrologypro/astrologupro_new_logo_bnnr.webp"
                  alt="AstrologyPro" />
                </div>
              </div>
              <h1 data-text="SCHOOL OF OUR DIVINE">SCHOOL OF OUR DIVINE </h1>
              <h1 data-text="infinite being">INFINITE BEING</h1>

              <h2>
                Polytheistic Monism - Divine Theurgy - Oracle to the Gods<br />
                Your initiation now unlocks <span className="orng_txt">AstrologyPro,</span> a unified system of advanced charts and <span>sacred insights.</span>

 
                </h2>
              <div className="ritualpraxis_bottombannerbg bannerboxtxt">
                <div className="yellow_bar"></div>
              </div>
            </div>
          </div>
        </div>
        <div className="signupfrom_New_section_28jul_mainWrp">
          <div className="signupfrom_New_section_28jul_cmn_wdh">
            <div className="signupfrom_New_section_28jul">
              <div className="signupfrom_New_section_12Aug_heading">
                <h3>Welcome to Our Living Circle of Wisdom</h3>
              </div>
              <div className="signupfrom_New_section_12Aug_txt">
                <p>
                  We warmly invite individuals, couples, and families to join a growing community like-minded souls who honor the timeless insights of Astrology and the living
                  traditions of perennial wisdom. Here, we gather in sacred fellowship to learn,
                  grow, and celebrate the spiritual arts - through teachings and trainings in astrology, yoga, meditation, tarot and the sacred texts of the world’s great lineages.

                </p>


                <p>
                  As a member, you’ll receive access to a private Backoffice that offers
                  personalized chart readings for all ages (7 and up), carefully attuned to
                  each stage of life. You’ll be able to participate in our monthly public rituals
                  via webcast -- beautifully woven ceremonies that align us with the rhythms of
                  the cosmos. In our members-only gatherings, families are encouraged to sit
                  together as we read aloud and reflect on sacred texts such as the Bhagavad
                  Gita, the Gospel of Thomas, and the Tao Te Ching.
                </p>


                <p>
                  We also offer special trainings for children, teens, and adults in the rich
                  symbolism of astrology, tarot, and Jungian archetypes -- creating a space
                  where spiritual learning becomes a shared journey across generations. Our
                  intimate community meetings bring heart-centered, spiritually grounded
                  connection into focus, weaving together the mystical with the practical in
                  everyday life.
                </p>


                <p>
                  <span>Come take your place in a community devoted to awakening, understanding,
                    and the shared joy of inner discovery.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Tirthayan custom addition: AstrologyPro connected-access trust banner */}
        {/* <div className="perennial_signup_access_banner_main">
          <div className="perennial_signup_access_banner">
            <div className="perennial_signup_access_banner_copy">
              <span className="perennial_signup_access_banner_label">
                <span
                  className="perennial_signup_access_banner_label_icon"
                  aria-hidden="true"
                >
                  ✦
                </span>
                <span className="perennial_signup_access_banner_label_text">
                  Connected Access
                </span>
              </span>
              <h4>
                Your initiation unlocks <span>AstrologyPro Access</span>
              </h4>
              <p>
                Enter a unified system of advanced charts, sacred insights,
                and deeper astrological intelligence.
              </p>
            </div>
            <img
              className="perennial_signup_access_banner_logo"
              src="/image/astrologypro/astrologypro-logo.png"
              alt="AstrologyPro"
            />
          </div>
        </div> */}

        {/* Rajdeep: custom addition: AstrologyPro connected-access trust banner */}

        <div className="astrologypro_access_wrpr">

          <div className="astrologypro_access_wrpr_cmn_wdh">

            <div className="astrologypro_access_wrpr_innr">

              <div className="astrologypro_access_wrpr_left">
                <img className="astrologypro_access_wrpr_left_img"
                  src="/image/astrologypro/astrologypro_logo_img.webp"
                  alt="AstrologyPro" />
              </div>

              <div className="astrologypro_access_wrpr_right">

                <div className="astrologypro_txt">
                  <h1><span className="grey_txt_clip">Your initiation unlocks </span> <span className="sky_blue">AstrologyPro Access</span></h1>
                  <p>Enter a unified system of advanced charts, sacred insights, and deeper astrological intelligence.</p>
                </div>

                <div className="connected_access_btn">
                  <span>Connected Access</span>
                  <img src=" /image/astrologypro/access_img.webp" alt="access_img" className="abs_img" />
                </div>

              </div>

            </div>

          </div>
        </div>


        {/* Rajdeep: custom addition: AstrologyPro connected-access trust banner */}

        <div className="sub_modal_banner_new">
          <div className="gred_txt">
            <h3>
              <span>Join our Community as an Individual, Couple or Family </span>
            </h3>
          </div>

          <p className="notification_message">
            Fields marked with an asterisk (*) are required.
          </p>

          <div className="mdl_form_sec mdl_form_sec_New_28jul">
            <form
              className="mdl_form"
              // Add noValidate to prevent default browser validation popups
              noValidate
              onSubmit={(e) => {
                e.preventDefault();
                handleSignupAndInitiatePayment();
              }}
            >
              {formData &&
                formData.map((item, index) => {
                  return (
                    // The entire .map() block remains the same...
                    // I've ensured all your `inputRef` props are correct.
                    // No changes are needed inside the JSX.
                    <div key={index}>
                      {index != 0 && (
                        <div className="gred_txt">
                          <h3>
                            <span>Add another member</span>
                          </h3>

                          <div className="btn_wrpr add_partner_button">
                            <Tooltip title="Remove Partner">
                              <IconButton onClick={() => removePartner(index)}>
                                <RemoveIcon />
                                <KeyboardDoubleArrowUpIcon />
                              </IconButton>
                            </Tooltip>
                          </div>
                        </div>
                      )}

                      {index != 0 && (
                        <FormControl className="from_input form_field_wrapperstate full_filed">
                          <InputLabel id="demo-simple-select-helper-label">
                            {" "}
                            * Relation
                          </InputLabel>
                          <Select
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="* Relation"
                            name="relation"
                            value={item.relation}
                            onChange={(e) => handelFormData(e, index)}
                            inputRef={getFieldRef(index, "relation")} // Added ref for completeness
                            error={!!error[index]?.relation}
                          >
                            <MenuItem
                              className="contact_menu_item"
                              value="Couple"
                            >
                              Partner/Couple
                            </MenuItem>
                            <MenuItem
                              className="contact_menu_item"
                              value="Family"
                            >
                              Family
                            </MenuItem>
                          </Select>
                          {error[index]?.relation && (
                            <FormHelperText id="my-helper-text">
                              {error[index]?.relation}
                            </FormHelperText>
                          )}
                        </FormControl>
                      )}

                      {index !== 0 &&
                        item.relation && ( // Only show if a relation is selected
                          <FormControl className="from_input form_field_wrapperstate full_filed">
                            <InputLabel id="sub-relation-label">
                              {" "}
                              * Relationship Type
                            </InputLabel>


                            <Select
                              className="contact_select_menu"
                              id="demo-simple-select-helper"
                              label="* Relationship Type" // Bonus fix: Made this match the InputLabel
                              name="sub_relation"
                              value={item.sub_relation || ""} // Use || '' to ensure the value is never undefined
                              onChange={(e) => handelFormData(e, index)}
                              inputRef={getFieldRef(index, "sub_relation")}
                              error={!!error[index]?.sub_relation}
                            >
                              {item.relation === "Couple" && [
                                <MenuItem
                                  key="Husband"
                                  className="contact_menu_item"
                                  value="Husband"
                                >
                                  Husband
                                </MenuItem>,
                                <MenuItem
                                  key="Wife"
                                  className="contact_menu_item"
                                  value="Wife"
                                >
                                  Wife
                                </MenuItem>,
                              ]}
                              {item.relation === "Family" && [
                                // <MenuItem
                                //   key="Father"
                                //   className="contact_menu_item"
                                //   value="Father"
                                // >
                                //   Father
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Mother"
                                //   className="contact_menu_item"
                                //   value="Mother"
                                // >
                                //   Mother
                                // </MenuItem>,
                                <MenuItem
                                  key="Son"
                                  className="contact_menu_item"
                                  value="Son"
                                >
                                  Son
                                </MenuItem>,
                                <MenuItem
                                  key="Daughter"
                                  className="contact_menu_item"
                                  value="Daughter"
                                >
                                  Daughter
                                </MenuItem>,
                                // <MenuItem
                                //   key="Brother"
                                //   className="contact_menu_item"
                                //   value="Brother"
                                // >
                                //   Brother
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Sister"
                                //   className="contact_menu_item"
                                //   value="Sister"
                                // >
                                //   Sister
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Grandfather"
                                //   className="contact_menu_item"
                                //   value="Grandfather"
                                // >
                                //   Grandfather
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Grandmother"
                                //   className="contact_menu_item"
                                //   value="Grandmother"
                                // >
                                //   Grandmother
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Uncle"
                                //   className="contact_menu_item"
                                //   value="Uncle"
                                // >
                                //   Uncle
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Aunt"
                                //   className="contact_menu_item"
                                //   value="Aunt"
                                // >
                                //   Aunt
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Nephew"
                                //   className="contact_menu_item"
                                //   value="Nephew"
                                // >
                                //   Nephew
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Niece"
                                //   className="contact_menu_item"
                                //   value="Niece"
                                // >
                                //   Niece
                                // </MenuItem>,
                                // <MenuItem
                                //   key="Cousin"
                                //   className="contact_menu_item"
                                //   value="Cousin"
                                // >
                                //   Cousin
                                // </MenuItem>,
                                <MenuItem
                                  key="Spouse"
                                  className="contact_menu_item"
                                  value="Spouse"
                                >
                                  Spouse
                                </MenuItem>,
                                <MenuItem
                                  key="Partner"
                                  className="contact_menu_item"
                                  value="Partner"
                                >
                                  Partner
                                </MenuItem>,

                                <MenuItem
                                  key="Other"
                                  className="contact_menu_item"
                                  value="Other"
                                >
                                  Other Family Member
                                </MenuItem>,
                              ]}
                            </Select>
                            {error[index]?.sub_relation && (
                              <FormHelperText id="my-helper-text">
                                {error[index]?.sub_relation}
                              </FormHelperText>
                            )}
                          </FormControl>
                        )}

                      <div className="mdl_form_flex perennial_mandalism_form perenial_flex_class">
                        {/* <TextField
                          inputRef={getFieldRef(index, "firstname")}
                          className="from_input form_field_wrapperfname"
                          value={item.firstname}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.firstname}
                          helperText={error[index]?.firstname}
                          id="outlined-basic"
                          name="firstname"
                          variant="outlined"
                          label="* First Name"
                          onKeyDown={() => {
                            let obj = [...error];
                            if (obj[index]?.firstname) {
                              delete obj[index]["firstname"];
                            }
                            setError(obj);
                          }}
                        /> */}

                        <TextField
                          ref={getFieldRef(index, "firstname")}
                          className="from_input form_field_wrapperfname"
                          value={item.firstname}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.firstname}
                          helperText={error[index]?.firstname}
                          name="firstname"
                          variant="outlined"
                          label="* First Name"
                        />

                        {/* <TextField
                          inputRef={getFieldRef(index, "lastname")}
                          className="from_input form_field_wrapperfname"
                          value={item.lastname}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.lastname}
                          helperText={error[index]?.lastname}
                          id="outlined-basic"
                          name="lastname"
                          variant="outlined"
                          label="* Last Name"
                          onKeyDown={() => {
                            let obj = [...error];
                            if (obj[index]?.lastname) {
                              delete obj[index]["lastname"];
                            }
                            setError(obj);
                          }}
                        /> */}

                        <TextField
                          ref={getFieldRef(index, "lastname")}
                          className="from_input form_field_wrapperfname"
                          value={item.lastname}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.lastname}
                          helperText={error[index]?.lastname}
                          name="lastname"
                          variant="outlined"
                          label="* Last Name"
                        />

                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            label="* Date of Birth"
                            // Display: parse from YYYY-MM-DD string to dayjs
                            value={
                              item.dob ? dayjs(item.dob, "YYYY-MM-DD") : null
                            }
                            onChange={(newValue) => {
                              const formattedDate = newValue
                                ? dayjs(newValue).format("YYYY-MM-DD") // 👈 only date, no time
                                : "";

                              handelFormData(
                                {
                                  target: {
                                    name: "dob",
                                    value: formattedDate,
                                  },
                                },
                                index
                              );
                            }}
                            slotProps={{
                              textField: {
                                inputRef: getFieldRef(index, "dob"),
                                variant: "outlined",
                                className: "from_input form_field_wrapperfname",
                                error: !!error[index]?.dob,
                                helperText: error[index]?.dob,
                                onKeyDown: () => {
                                  let obj = [...error];
                                  if (obj[index]?.dob) delete obj[index]["dob"];
                                  setError(obj);
                                },
                              },
                            }}
                          />
                        </LocalizationProvider> */}

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          {/* FIX 2: Moved ref from slotProps to the main DatePicker component */}
                          <DatePicker
                            ref={getFieldRef(index, "dob")}
                            label="* Date of Birth"
                            value={item.dob ? dayjs(item.dob, "YYYY-MM-DD") : null}
                            onChange={(newValue) => {
                              const formattedDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : "";
                              handelFormData({ target: { name: "dob", value: formattedDate } }, index);
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                className: "from_input form_field_wrapperfname",
                                error: !!error[index]?.dob,
                                helperText: error[index]?.dob,
                              },
                            }}
                          />
                        </LocalizationProvider>

                        {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <TimePicker
                            className="timedateSectionSignup"
                            label="* Time of Birth"
                            // 👇 Display: convert "06:35 PM" string to dayjs object
                            value={
                              item.time_of_birth
                                ? dayjs(item.time_of_birth, "hh:mm A") // <-- strictly format as time string
                                : null
                            }
                            onChange={(newValue) => {
                              // 👇 Format selected time to "hh:mm A" (string only)
                              const formatted = newValue
                                ? dayjs(newValue).format("hh:mm A") // e.g., "06:35 PM"
                                : "";

                              handelFormData(
                                {
                                  target: {
                                    name: "time_of_birth",
                                    value: formatted, // 👈 Only this formatted string is stored!
                                  },
                                },
                                index
                              );
                            }}
                            slotProps={{
                              textField: {
                                inputRef: getFieldRef(index, "time_of_birth"),
                                variant: "outlined",
                                className: "from_input form_field_wrapperfname",
                                error: !!error[index]?.time_of_birth,
                                helperText: error[index]?.time_of_birth,
                                onKeyDown: () => {
                                  let obj = [...error];
                                  if (obj[index]?.time_of_birth)
                                    delete obj[index]["time_of_birth"];
                                  setError(obj);
                                },
                              },
                            }}
                          />
                        </LocalizationProvider> */}

                        <FormControl
                          ref={getFieldRef(index, "state")}
                          className="from_input form_field_wrapperstate"
                          error={!!error[index]?.state}
                        >
                          <InputLabel id="state-label">* State</InputLabel>
                          <Select
                            labelId="state-label"
                            label="* State"
                            name="state"
                            value={item.state}
                            onChange={(e) => handelFormData(e, index)}
                          >
                            {StateArray &&
                              StateArray.map((itemd) => (
                                <MenuItem key={itemd.val} value={itemd.val}>
                                  {itemd.name}
                                </MenuItem>
                              ))}
                          </Select>
                          {error[index]?.state && (
                            <FormHelperText>{error[index]?.state}</FormHelperText>
                          )}
                        </FormControl>

                        {/* <Autocomplete
                          freeSolo
                          className="from_input form_field_wrapperfname"
                          options={cityOptions}
                          getOptionLabel={(option) =>
                            typeof option === "string" ? option : option.val
                          }
                          inputValue={item.city}
                          onInputChange={(event, newInputValue) => {
                            handelFormData(
                              {
                                target: { name: "city", value: newInputValue },
                              },
                              index
                            );
                            debouncedFetchCitySuggestions(newInputValue);
                          }}
                          onChange={async (event, selectedOption) => {
                            const selectedVal =
                              typeof selectedOption === "string"
                                ? selectedOption
                                : selectedOption?.val;

                            handelFormData(
                              {
                                target: {
                                  name: "city",
                                  value: selectedVal || "",
                                },
                              },
                              index
                            );

                            let obj = [...error];
                            if (obj[index]?.city) {
                              delete obj[index]["city"];
                              setError(obj);
                            }

                            if (selectedVal) {
                              await fetchCityLatLon(selectedVal);
                            }
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              inputRef={getFieldRef(index, "city")}
                              label="* City"
                              error={!!error[index]?.city}
                              helperText={error[index]?.city}
                            />
                          )}
                        /> */}

                        <Autocomplete
                          ref={getFieldRef(index, "city")}
                          freeSolo
                          className="from_input form_field_wrapperfname"
                          options={cityOptions}
                          getOptionLabel={(option) => (typeof option === "string" ? option : option.val)}
                          inputValue={item.city}
                          onInputChange={(event, newInputValue) => {
                            handelFormData({ target: { name: "city", value: newInputValue } }, index);
                            debouncedFetchCitySuggestions(newInputValue);
                          }}
                          onChange={async (event, selectedOption) => {
                            // ... (your existing onChange logic)
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="* City"
                              error={!!error[index]?.city}
                              helperText={error[index]?.city}
                            />
                          )}
                        />

                        {/* <TextField
                          onKeyPress={(e) => {
                            if (error[index]?.zip) {
                              delete error[index]["zip"];
                            }
                            if (e.which < 48 || e.which > 57) {
                              e.preventDefault();
                            }
                          }}
                          value={item.zip}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.zip}
                          helperText={error[index]?.zip}
                          inputRef={getFieldRef(index, "zip")}
                          className="from_input form_field_wrapperfname"
                          id="outlined-basic"
                          name="zip"
                          variant="outlined"
                          label="* Zip"
                        /> */}


                        <TextField
                          ref={getFieldRef(index, "zip")}
                          onKeyPress={(e) => {
                            if (e.which < 48 || e.which > 57) e.preventDefault();
                          }}
                          value={item.zip}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.zip}
                          helperText={error[index]?.zip}
                          className="from_input form_field_wrapperfname"
                          name="zip"
                          variant="outlined"
                          label="* Zip"
                        />

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          {/* FIX 2: Moved ref from slotProps to the main TimePicker component */}
                          <TimePicker
                            ref={getFieldRef(index, "time_of_birth")}
                            className="timedateSectionSignup"
                            label="* Time of Birth"
                            value={item.time_of_birth ? dayjs(item.time_of_birth, "hh:mm A") : null}
                            onChange={(newValue) => {
                              const formatted = newValue ? dayjs(newValue).format("hh:mm A") : "";
                              handelFormData({ target: { name: "time_of_birth", value: formatted } }, index);
                            }}
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                className: "from_input form_field_wrapperfname",
                                error: !!error[index]?.time_of_birth,
                                helperText: error[index]?.time_of_birth,
                              },
                            }}
                          />
                        </LocalizationProvider>
                        {/* 
                        <TextField
                          inputRef={getFieldRef(index, "email")}
                          className="from_input form_field_wrapperfname"
                          value={item.email}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.email}
                          helperText={error[index]?.email}
                          id="outlined-basic"
                          name="email"
                          variant="outlined"
                          label="* Email"
                          onKeyDown={() => {
                            let obj = [...error];
                            if (obj[index]?.email) {
                              delete obj[index]["email"];
                            }
                            setError(obj);
                          }}
                        /> */}



                        <TextField
                          ref={getFieldRef(index, "email")}
                          className="from_input form_field_wrapperfname"
                          value={item.email}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.email}
                          helperText={error[index]?.email}
                          name="email"
                          variant="outlined"
                          label="* Email"
                        />

                        {/* <TextField
                          onKeyPress={(e) => {
                            if (error[index]?.phone) {
                              delete error[index]["phone"];
                            }
                            if (e.which < 48 || e.which > 57) {
                              e.preventDefault();
                            }
                          }}
                          value={item.phone}
                          onChange={(e) => phoneFormatting(e, index)}
                          error={!!error[index]?.phone}
                          helperText={error[index]?.phone}
                          inputRef={getFieldRef(index, "phone")}
                          className="from_input form_field_wrapperfname"
                          id="outlined-basic"
                          name="phone"
                          variant="outlined"
                          label="* Phone"
                        /> */}


                        <TextField
                          ref={getFieldRef(index, "phone")}
                          onKeyPress={(e) => {
                            if (e.which < 48 || e.which > 57) e.preventDefault();
                          }}
                          value={item.phone}
                          onChange={(e) => phoneFormatting(e, index)}
                          error={!!error[index]?.phone}
                          helperText={error[index]?.phone}
                          className="from_input form_field_wrapperfname"
                          name="phone"
                          variant="outlined"
                          label="* Phone"
                        />
                        {/* <FormControl
                          className="from_input form_field_wrapperstate"
                          error={!!error[index]?.gender}
                        >
                          <InputLabel id="demo-simple-select-helper-label">
                            {" "}
                            * Gender{" "}
                          </InputLabel>

                          <Select
                            inputRef={getFieldRef(index, "gender")}
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="* Gender"
                            name="gender"
                            value={item.gender}
                            onChange={(e) => handelFormData(e, index)}
                          >
                            <MenuItem
                              className="contact_menu_item"
                              value="male"
                            >
                              Male
                            </MenuItem>
                            <MenuItem
                              className="contact_menu_item"
                              value="female"
                            >
                              Female
                            </MenuItem>
                            <MenuItem
                              className="contact_menu_item"
                              value="other"
                            >
                              Other
                            </MenuItem>
                          </Select>

                          {error[index]?.gender && (
                            <FormHelperText id="my-helper-text">
                              {error[index]?.gender}
                            </FormHelperText>
                          )}
                        </FormControl> */}


                        <FormControl
                          ref={getFieldRef(index, "gender")}
                          className="from_input form_field_wrapperstate"
                          error={!!error[index]?.gender}
                        >
                          <InputLabel id="gender-label">* Gender</InputLabel>
                          <Select
                            labelId="gender-label"
                            label="* Gender"
                            name="gender"
                            value={item.gender}
                            onChange={(e) => handelFormData(e, index)}
                          >
                            <MenuItem value="male">Male</MenuItem>
                            <MenuItem value="female">Female</MenuItem>
                            <MenuItem value="other">Other</MenuItem>
                          </Select>
                          {error[index]?.gender && (
                            <FormHelperText>{error[index]?.gender}</FormHelperText>
                          )}
                        </FormControl>

                        {/* <FormControl
                          className="from_input form_field_wrapperstate"
                          error={!!error[index]?.state}
                        >
                          <InputLabel id="demo-simple-select-helper-label">
                            {" "}
                            * State{" "}
                          </InputLabel>
                          <Select
                            inputRef={getFieldRef(index, "state")}
                            className="contact_select_menu"
                            id="demo-simple-select-helper"
                            label="* State"
                            name="state"
                            value={item.state}
                            onChange={(e) => handelFormData(e, index)}
                          >
                            {StateArray &&
                              StateArray.map((itemd, index) => {
                                return (
                                  <MenuItem
                                    key={index}
                                    className="contact_menu_item"
                                    value={itemd.val}
                                  >
                                    {" "}
                                    {itemd.name}{" "}
                                  </MenuItem>
                                );
                              })}
                          </Select>
                          {error[index]?.state && (
                            <FormHelperText id="my-helper-text">
                              {error[index]?.state}
                            </FormHelperText>
                          )}
                        </FormControl> */}


                        {/* <TextField
                          value={item.occupation || ""}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.occupation}
                          helperText={error[index]?.occupation}
                          inputRef={getFieldRef(index, "occupation")}
                          className="from_input form_field_wrapperfname"
                          id="outlined-basic"
                          variant="outlined"
                          label="* Occupation"
                          name="occupation"
                          onKeyDown={() => {
                            let obj = [...error];
                            if (obj[index]?.occupation) {
                              delete obj[index]["occupation"];
                            }
                            setError(obj);
                          }}
                        /> */}


                        <TextField
                          ref={getFieldRef(index, "occupation")}
                          value={item.occupation || ""}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.occupation}
                          helperText={error[index]?.occupation}
                          className="from_input form_field_wrapperfname"
                          name="occupation"
                          variant="outlined"
                          label="* Occupation"
                        />

                        {/* <TextField
                          value={item.address}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.address}
                          helperText={error[index]?.address}
                          inputRef={getFieldRef(index, "address")}
                          className="from_input  form_field_wrapperfname"
                          id="outlined-basic"
                          variant="outlined"
                          label="* Full Address"
                          name="address"
                          onKeyDown={() => {
                            let obj = [...error];
                            if (obj[index]?.address) {
                              delete obj[index]["address"];
                            }
                            setError(obj);
                          }}
                        /> */}

                        <TextField
                          ref={getFieldRef(index, "address")}
                          value={item.address}
                          onChange={(e) => handelFormData(e, index)}
                          error={!!error[index]?.address}
                          helperText={error[index]?.address}
                          className="from_input form_field_wrapperfname"
                          name="address"
                          variant="outlined"
                          label="* Full Address"
                        />

                        <div className="full_filed password_sec password_sec">
                          <div className="password_field_for_perenomial_mandelisom  ">
                            <TextField
                              label="* Password"
                              variant="outlined"
                              inputRef={getFieldRef(index, "password")}
                              className="password_field_for_perenomial from_input form_field_wrapperfname"
                              id="outlined-basic"
                              name="password"
                              type={showPass ? "text" : "password"}
                              value={item?.password ? item.password : ""}
                              onChange={(e) => handelFormData(e, index)}
                              error={!!error[index]?.password}
                              helperText={error[index]?.password}
                              onKeyDown={() => {
                                let obj = [...error];
                                if (obj[index]?.password) {
                                  delete obj[index]["password"];
                                }
                                setError(obj);
                              }}
                            />

                            <span
                              className="password_field_for_view"
                              onClick={() => setShowPass(!showPass)}
                            >
                              {showPass ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </span>
                          </div>

                          <div className="password_field_for_perenomial_mandelisom  ">
                            <TextField
                              label="* Confirm Password"
                              inputRef={getFieldRef(index, "confirm_password")}
                              className="password_field_for_perenomial from_input form_field_wrapperfname"
                              id="outlined-basic"
                              name="confirm_password"
                              variant="outlined"
                              type={showConPass ? "text" : "password"}
                              value={
                                item?.confirm_password
                                  ? item.confirm_password
                                  : ""
                              }
                              onChange={(e) => handelFormData(e, index)}
                              error={!!error[index]?.confirm_password}
                              helperText={error[index]?.confirm_password}
                              onKeyDown={() => {
                                let obj = [...error];
                                if (obj[index]?.confirm_password) {
                                  delete obj[index]["confirm_password"];
                                }
                                setError(obj);
                              }}
                            />

                            <span
                              className="password_field_for_view"
                              onClick={() => setShowConPass(!showConPass)}
                            >
                              {showConPass ? (
                                <VisibilityIcon />
                              ) : (
                                <VisibilityOffIcon />
                              )}
                            </span>
                          </div>
                        </div>

                        <div className="signup_frompage_New_SubBlk_wrp">
                          <p><span>The following questions are not required, but because we run <br />you and your Family's astrology it can help us curate <br />more specialized responses from our engine.</span></p>
                        </div>
                        <div className="signup_frompage_OpenHide_btn_main">
                          <span className="signup_frompage_OpenHide_btn" onClick={() => handleToggle(index)}>
                            {/* {isVisible[index] ? "Hide Section" : "Show Section"} */}
                            {isVisible[index] ? "Collapse Section to Hide Details" : "Expand Section for Complete Details"}
                            {isVisible[index] ? <RemoveIcon /> : <AddIcon />}

                          </span>
                        </div>
                        <div
                          className="mdl_form_flex perennial_mandalism_form perenial_flex_class accoridianClass_Signup_From"
                        // className={`mdl_form_flex perennial_mandalism_form perenial_flex_class transition-section ${isVisible[0] ? "open" : ""}`}
                        >
                          {isVisible[index] && (
                            <>

                              <Grid item xs={12}>
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    color: "#ff9800",
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Relationship Status
                                </Typography>

                                <RadioGroup
                                  row
                                  name="relationship_status"
                                  value={item.relationship_status || ""}
                                  onChange={(e) => {
                                    handelFormData(
                                      {
                                        target: {
                                          name: "relationship_status",
                                          value: e.target.value,
                                        },
                                      },
                                      index
                                    );
                                  }}
                                  sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "20px",
                                  }}
                                >
                                  {[
                                    "Single",
                                    "Married",
                                    "Separated",
                                    "Divorced",
                                    "Widowed",
                                  ].map((status) => (
                                    <FormControlLabel
                                      key={status}
                                      value={status}
                                      control={
                                        <Radio
                                          sx={{
                                            color: "#ff9800",
                                            "&.Mui-checked": {
                                              color: "#ff9800",
                                            },
                                          }}
                                        />
                                      }
                                      label={status}
                                      sx={{
                                        color: "#fff",
                                        margin: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        ".MuiFormControlLabel-label": {
                                          fontSize: "14px",
                                          lineHeight: "1",
                                        },
                                      }}
                                    />
                                  ))}
                                </RadioGroup>
                              </Grid>

                              <div className="full_filed password_sec password_sec">
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    color: "#ff9800",
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  Personality and Life
                                </Typography>
                              </div>
                              <TextField
                                value={item.personality}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.personality}
                                helperText={error[index]?.personality}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Describe Your Personality"
                                name="personality"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.personality) {
                                    delete obj[index]["personality"];
                                  }
                                  setError(obj);
                                }}
                              />

                              <TextField
                                value={item.strengths}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.strengths}
                                helperText={error[index]?.strengths}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Primary Strengths and Talents"
                                name="strengths"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.strengths) {
                                    delete obj[index]["strengths"];
                                  }
                                  setError(obj);
                                }}
                              />
                              <TextField
                                value={item.lifeAreasFulfilling}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.lifeAreasFulfilling}
                                helperText={error[index]?.lifeAreasFulfilling}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Life Areas Currently Fulfilling"
                                name="lifeAreasFulfilling"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.lifeAreasFulfilling) {
                                    delete obj[index]["lifeAreasFulfilling"];
                                  }
                                  setError(obj);
                                }}
                              />
                              <TextField
                                value={item.lifeAreasImprovement}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.lifeAreasImprovement}
                                helperText={error[index]?.lifeAreasImprovement}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Life Areas Needing Improvement"
                                name="lifeAreasImprovement"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.lifeAreasImprovement) {
                                    delete obj[index]["lifeAreasImprovement"];
                                  }
                                  setError(obj);
                                }}
                              />
                              <TextField
                                value={item.longTermGoals}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.longTermGoals}
                                helperText={error[index]?.longTermGoals}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Long-Term Goals and Aspirations"
                                name="longTermGoals"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.longTermGoals) {
                                    delete obj[index]["longTermGoals"];
                                  }
                                  setError(obj);
                                }}
                              />
                              <TextField
                                value={item.majorLifeEvents}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.majorLifeEvents}
                                helperText={error[index]?.majorLifeEvents}
                                className="from_input form_field_wrapperfname textariya_sign_up"
                                id="outlined-basic"
                                variant="outlined"
                                label="Major Life Events/Experiences"
                                name="majorLifeEvents"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.majorLifeEvents) {
                                    delete obj[index]["majorLifeEvents"];
                                  }
                                  setError(obj);
                                }}
                              />
                              <div
                                style={{
                                  marginTop: "20px",
                                  display: "flex",
                                  gap: "40px",
                                  flexWrap: "wrap",
                                  width: "65%",
                                  marginBottom: "20px",
                                }}
                              >
                                <div
                                  style={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "white",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Stress Management (Do you find it challenging to
                                      handle stress?)
                                    </Typography>
                                    <Switch
                                      checked={item.stressManagement || false}
                                      onChange={(e) =>
                                        handelFormData(
                                          {
                                            target: {
                                              name: "stressManagement",
                                              value: e.target.checked,
                                            },
                                          },
                                          index
                                        )
                                      }
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "#ff9800",
                                        },
                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                        {
                                          backgroundColor: "#ff9800",
                                        },
                                      }}
                                    />
                                  </div>
                                </div>

                                <div
                                  style={{
                                    flex: 1,
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography
                                      style={{
                                        color: "white",
                                        marginRight: "10px",
                                      }}
                                    >
                                      Work-Life Balance (Do you feel you have a good
                                      balance? Yes/No)
                                    </Typography>
                                    <Switch
                                      checked={item.workLifeBalance || false}
                                      onChange={(e) =>
                                        handelFormData(
                                          {
                                            target: {
                                              name: "workLifeBalance",
                                              value: e.target.checked,
                                            },
                                          },
                                          index
                                        )
                                      }
                                      sx={{
                                        "& .MuiSwitch-switchBase.Mui-checked": {
                                          color: "#ff9800",
                                        },
                                        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                        {
                                          backgroundColor: "#ff9800",
                                        },
                                      }}
                                    />
                                  </div>
                                </div>
                              </div>

                              <div className="full_filed password_sec password_sec">
                                <Typography
                                  variant="subtitle1"
                                  sx={{
                                    color: "#ff9800",
                                    fontWeight: "bold",
                                    marginBottom: "10px",
                                  }}
                                >
                                  {/* Relationships and Social Dynamics and Current Situations and Challenges */}
                                  Relationships, Social Dynamics, and Current Challenges
                                </Typography>
                                <TextField
                                  value={item.relationship_with_family}
                                  onChange={(e) => handelFormData(e, index)}
                                  error={!!error[index]?.relationship_with_family}
                                  helperText={error[index]?.relationship_with_family}
                                  className="from_input form_field_wrapperfname textariya_sign_up"
                                  id="outlined-basic"
                                  variant="outlined"
                                  label="Describe any current challenges in your work or personal life..."
                                  name="relationship_with_family"
                                  onKeyDown={() => {
                                    let obj = [...error];
                                    if (obj[index]?.relationship_with_family) {
                                      delete obj[index]["relationship_with_family"];
                                    }
                                    setError(obj);
                                  }}
                                />
                              </div>

                              <div style={{ display: "flex", justifyContent: "space-around", alignItems: "center", width: "100%", flexDirection: "column" }}>
                                <div
                                  style={{
                                    marginTop: "20px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "15px",
                                    width: "100%",
                                  }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      gap: "30px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flex: isMobile ? "1 1 100%" : "1 1 32%",
                                      }}
                                    >
                                      <Typography style={{ color: "white" }}>
                                        Focus on Specific Relationships (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={
                                          item.focus_on_specific_relationships || false
                                        }
                                        onChange={(e) =>
                                          handelFormData(
                                            {
                                              target: {
                                                name: "focus_on_specific_relationships",
                                                value: e.target.checked,
                                              },
                                            },
                                            index
                                          )
                                        }
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked": {
                                            color: "#ff9800",
                                          },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#ff9800",
                                          },
                                        }}
                                      />
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flex: isMobile ? "1 1 100%" : "1 1 32%",
                                      }}
                                    >
                                      <Typography style={{ color: "white" }}>
                                        Guidance on Specific Decision/Situation (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={
                                          item.guidance_on_specific_decision || false
                                        }
                                        onChange={(e) =>
                                          handelFormData(
                                            {
                                              target: {
                                                name: "guidance_on_specific_decision",
                                                value: e.target.checked,
                                              },
                                            },
                                            index
                                          )
                                        }
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked": {
                                            color: "#ff9800",
                                          },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#ff9800",
                                          },
                                        }}
                                      />
                                    </div>

                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        flex: isMobile ? "1 1 100%" : "1 1 32%",
                                      }}
                                    >
                                      <Typography style={{ color: "white" }}>
                                        Concerns About Romantic Life (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={
                                          item.concerns_about_romantic_life || false
                                        }
                                        onChange={(e) =>
                                          handelFormData(
                                            {
                                              target: {
                                                name: "concerns_about_romantic_life",
                                                value: e.target.checked,
                                              },
                                            },
                                            index
                                          )
                                        }
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked": {
                                            color: "#ff9800",
                                          },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#ff9800",
                                          },
                                        }}
                                      />
                                    </div>



                                  </div>

                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "flex-start",
                                      gap: "30px",
                                      flexWrap: "wrap",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        //  flex: isMobile ? "1 1 100%" : "1 1 33%",
                                        width: isMobile ? "100%" : "32%",
                                      }}
                                    >
                                      <Typography style={{ color: "white" }}>
                                        Ongoing Projects or Plans (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={
                                          item.ongoing_projects_or_plans || false
                                        }
                                        onChange={(e) =>
                                          handelFormData(
                                            {
                                              target: {
                                                name: "ongoing_projects_or_plans",
                                                value: e.target.checked,
                                              },
                                            },
                                            index
                                          )
                                        }
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked": {
                                            color: "#ff9800",
                                          },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#ff9800",
                                          },
                                        }}
                                      />
                                    </div>
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        // flex: isMobile ? "1 1 100%" : "1 1 33%",
                                        width: isMobile ? "100%" : "32%",
                                      }}
                                    >
                                      <Typography style={{ color: "white" }}>
                                        Social Life Fulfillment (Yes/No)
                                      </Typography>
                                      <Switch
                                        checked={item.social_life_fulfillment || false}
                                        onChange={(e) =>
                                          handelFormData(
                                            {
                                              target: {
                                                name: "social_life_fulfillment",
                                                value: e.target.checked,
                                              },
                                            },
                                            index
                                          )
                                        }
                                        sx={{
                                          "& .MuiSwitch-switchBase.Mui-checked": {
                                            color: "#ff9800",
                                          },
                                          "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                          {
                                            backgroundColor: "#ff9800",
                                          },
                                        }}
                                      />
                                    </div>
                                  </div>




                                </div>

                                <div style={{ marginTop: "10px", color: "white", width: "100%" }}>
                                  <div className="full_filed password_sec password_sec">
                                    <div className="password_field_for_perenomial_mandelisom " style={{ width: "100%" }}>
                                      <Typography
                                        variant="h6"
                                        sx={{ color: "#ff9800", fontWeight: "bold" }}
                                      >
                                        Spiritual and Personal Growth
                                      </Typography>
                                      <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: "20px" }}>
                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: isMobile ? "100%" : "32%",
                                          }}
                                        >
                                          <Typography style={{ color: "white" }}>
                                            Spiritual or Personal Growth Practices
                                          </Typography>
                                          <Switch
                                            checked={item.spiritualPractices || false}
                                            onChange={(e) =>
                                              handelFormData(
                                                {
                                                  target: {
                                                    name: "spiritualPractices",
                                                    value: e.target.checked,
                                                  },
                                                },
                                                index
                                              )
                                            }
                                            sx={{
                                              "& .MuiSwitch-switchBase.Mui-checked": {
                                                color: "#ff9800",
                                              },
                                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                              {
                                                backgroundColor: "#ff9800",
                                              },
                                            }}
                                          />
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: isMobile ? "100%" : "32%",
                                          }}
                                        >
                                          <Typography style={{ color: "white" }}>
                                            Exploring Self-Discovery/Personal Development
                                          </Typography>
                                          <Switch
                                            checked={item.selfDiscovery || false}
                                            onChange={(e) =>
                                              handelFormData(
                                                {
                                                  target: {
                                                    name: "selfDiscovery",
                                                    value: e.target.checked,
                                                  },
                                                },
                                                index
                                              )
                                            }
                                            sx={{
                                              "& .MuiSwitch-switchBase.Mui-checked": {
                                                color: "#ff9800",
                                              },
                                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                              {
                                                backgroundColor: "#ff9800",
                                              },
                                            }}
                                          />
                                        </div>

                                        <div
                                          style={{
                                            display: "flex",
                                            justifyContent: "space-between",
                                            alignItems: "center",
                                            width: isMobile ? "100%" : "32%",
                                          }}
                                        >
                                          <Typography style={{ color: "white" }}>
                                            Belief in External Influences on Life (Yes/No)
                                          </Typography>
                                          <Switch
                                            checked={item.externalInfluences || false}
                                            onChange={(e) =>
                                              handelFormData(
                                                {
                                                  target: {
                                                    name: "externalInfluences",
                                                    value: e.target.checked,
                                                  },
                                                },
                                                index
                                              )
                                            }
                                            sx={{
                                              "& .MuiSwitch-switchBase.Mui-checked": {
                                                color: "#ff9800",
                                              },
                                              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                              {
                                                backgroundColor: "#ff9800",
                                              },
                                            }}
                                          />
                                        </div>
                                      </div>

                                    </div>
                                    {/* 
                            <div className="password_field_for_perenomial_mandelisom ">
                              <Typography
                                variant="h6"
                                sx={{ color: "#ff9800", fontWeight: "bold" }}
                              >
                                Goals for the Reading
                              </Typography>

                              <TextField
                                value={item.achieveFromReading}
                                onChange={(e) => handelFormData(e, index)}
                                error={!!error[index]?.achieveFromReading}
                                helperText={error[index]?.achieveFromReading}
                                className="from_input"
                                id="achieve-reading-input"
                                variant="outlined"
                                label="Achieve from the Reading"
                                name="achieveFromReading"
                                onKeyDown={() => {
                                  let obj = [...error];
                                  if (obj[index]?.achieveFromReading) {
                                    delete obj[index]["achieveFromReading"];
                                  }
                                  setError(obj);
                                }}
                                multiline
                                rows={4}
                              />

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography style={{ color: "white" }}>
                                  Specific Questions/Topics to Address
                                </Typography>
                                <Switch
                                  checked={item.specificQuestions || false}
                                  onChange={(e) =>
                                    handelFormData(
                                      {
                                        target: {
                                          name: "specificQuestions",
                                          value: e.target.checked,
                                        },
                                      },
                                      index
                                    )
                                  }
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#ff9800",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#ff9800",
                                    },
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography style={{ color: "white" }}>
                                  Goals or Outcomes for the Reading
                                </Typography>
                                <Switch
                                  checked={item.goalsOutcomes || false}
                                  onChange={(e) =>
                                    handelFormData(
                                      {
                                        target: {
                                          name: "goalsOutcomes",
                                          value: e.target.checked,
                                        },
                                      },
                                      index
                                    )
                                  }
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#ff9800",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#ff9800",
                                    },
                                  }}
                                />
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <Typography style={{ color: "white" }}>
                                  Preference for Practical Advice vs. Spiritual
                                  Insights
                                </Typography>
                                <Switch
                                  checked={item.practicalSpiritualPref || false}
                                  onChange={(e) =>
                                    handelFormData(
                                      {
                                        target: {
                                          name: "practicalSpiritualPref",
                                          value: e.target.checked,
                                        },
                                      },
                                      index
                                    )
                                  }
                                  sx={{
                                    "& .MuiSwitch-switchBase.Mui-checked": {
                                      color: "#ff9800",
                                    },
                                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track":
                                    {
                                      backgroundColor: "#ff9800",
                                    },
                                  }}
                                />
                              </div>
                            </div> */}
                                  </div>

                                  <hr
                                    style={{
                                      borderColor: "#555",
                                      margin: "30px 0",
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="full_filed password_sec password_sec">
                                {/* <div className="password_field_for_perenomial_mandelisom ">
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#ff9800",
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              Current Situation
                            </Typography>
                            <TextField
                              value={item.mainConcern}
                              onChange={(e) => handelFormData(e, index)}
                              error={!!error[index]?.mainConcern}
                              helperText={error[index]?.mainConcern}
                              className="from_input"
                              id="main-concern-input"
                              variant="outlined"
                              label="Main Concern or Question Right Now"
                              name="mainConcern"
                              onKeyDown={() => {
                                let obj = [...error];
                                if (obj[index]?.mainConcern) {
                                  delete obj[index]["mainConcern"];
                                }
                                setError(obj);
                              }}
                              multiline
                              rows={4}
                            />
                          </div> */}

                                {/* <div className="password_field_for_perenomial_mandelisom ">
                            <Typography
                              variant="h6"
                              sx={{
                                color: "#ff9800",
                                fontWeight: "bold",
                                marginBottom: "10px",
                              }}
                            >
                              Additional Information
                            </Typography>
                            <TextField
                              value={item.additionalInfo}
                              onChange={(e) => handelFormData(e, index)}
                              error={!!error[index]?.additionalInfo}
                              helperText={error[index]?.additionalInfo}
                              className="from_input"
                              id="additional-info-input"
                              variant="outlined"
                              label="Anything Else to Share"
                              name="additionalInfo"
                              onKeyDown={() => {
                                let obj = [...error];
                                if (obj[index]?.additionalInfo) {
                                  delete obj[index]["additionalInfo"];
                                }
                                setError(obj);
                              }}
                              multiline
                              rows={4}
                            />
                            <TextField
                              style={{ width: "100%" }}
                              aria-label="minimum height"
                              className="from_input form_field_wrapperfname textariya_sign_up"
                              name="additional_info"
                              value={item.additional_info}
                              label="About"
                              onChange={(e) => handelFormData(e, index)}
                            />
                          </div>  */}
                              </div>
                            </>
                          )
                          }
                        </div>

                      </div>
                    </div>
                  );
                })}

              <div className="btn_wrpr add_partner_button">
                <Tooltip title="Add Partner">
                  <IconButton onClick={() => addFields()} disabled={loader} style={{ fontSize: "18px", textTransform: "capitalize", display: "flex", lineHeight: "24px", padding: "10px" }}>
                    add spouse or partner and family members
                    <AddIcon />
                    {/* <KeyboardDoubleArrowDownIcon /> */}
                  </IconButton>
                </Tooltip>
              </div>

              <div className="btn_wrpr payment_form_new">
                {pricingLoading ? (
                  <p className="price_pera_panalium_mendalitiom" style={{ fontSize: "14px", fontStyle: "italic" }}>
                    Loading pricing...
                  </p>
                ) : pricingError ? (
                  <p className="price_pera_panalium_mendalitiom" style={{ color: "red", fontSize: "14px" }}>
                    {pricingError}
                  </p>
                ) : (
                  <p className="price_pera_panalium_mendalitiom">
                    Subscription: {amount_and_type.type} -{" "}
                    {formatPlanPrice(
                      amount_and_type.amount,
                      amount_and_type.currency
                    )}
                    /{amount_and_type.interval || "month"}
                  </p>
                )}

                <Button type="submit" disabled={loader || pricingLoading || !!pricingError}>
                  Sign Up
                </Button>
              </div>
            </form>

            {loader && (
              <Box sx={{ width: "100%" }}>
                <LinearProgress />
              </Box>
            )}
          </div>
        </div>
      </div>

      <Modal
        open={isStripeModalOpen}
        onClose={handleCloseStripeModal}
        aria-labelledby="stripe-payment-modal-title"
        aria-describedby="stripe-payment-modal-description"
        className="banner_modal_main banner_modal_main_new banner_modal_main_new1"
      >
        <div className="main_wrpr_finddivine main_wrpr_payment_modal">
          <span className="close_btn" onClick={handleCloseStripeModal}>
            <CloseIcon />
          </span>

          <Box className="banner_modal_box_new banner_modal_box_neww">
            <Typography
              id="modal-modal-description"
              component="div"
              sx={{ mt: 2 }}
              className="modal_banner_new"
            >
              <div className="sub_modal_banner_new">
                <div className="gred_txt">
                  <h3>
                    <span>Complete Your Payment </span>
                  </h3>
                </div>

                <Typography
                  id="stripe-payment-modal-description"
                  sx={{ lineHeight: "30px !important" }}
                  className="price_pera_panalium_mendalitiom"
                >
                  Subscription: {amount_and_type?.type} -{" "}
                  {formatPlanPrice(
                    amount_and_type?.amount,
                    amount_and_type?.currency
                  )}
                  /{amount_and_type?.interval || "month"}
                </Typography>

                {clientSecret && (
                  <Elements options={stripeOptions} stripe={stripePromise}>
                    <StripePaymentModal
                      clientSecret={clientSecret}
                      onSubmit={handleStripeSubmit}
                      processing={stripeProcessing}
                      error={stripeError}
                    />
                  </Elements>
                )}
              </div>
            </Typography>
          </Box>
        </div>
      </Modal>

      <Snackbar
        open={snackbarState}
        autoHideDuration={4000}
        onClose={() => setSnackbarState(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        message={snackbarMassage}
        className="snack_msg"
      />
      <Modal
        open={open}
        onClose={handleCloseNew}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="banner_modal_main"
      >
        <Box className="banner_modal_box">
          <Typography
            id="modal-modal-description"
            component="div"
            sx={{ mt: 2 }}
            className="modal_banner"
          >
            <div className="sub_modal_banner">
              <span className="close_btn" onClick={handleCloseNew}>
                <CloseIcon />
              </span>
              <img
                src="https://all-frontend-assets.s3.amazonaws.com/transcendentpagan/assets/images/logobanner.webp"
                alt="bannerLogo"
              />
            </div>
          </Typography>
        </Box>
      </Modal>
    </>
  );
};

export default SignUpForm;
